import { isAxiosError } from 'axios'

/**
 * The JSON body of an API refusal, or null when there is none: no response, or a body that is not
 * JSON. A request made with `responseType: 'blob'` receives its JSON error body as a Blob, which is
 * read here.
 */
export async function apiErrorData(error: unknown): Promise<unknown> {
	if (!isAxiosError(error)) return null
	const data: unknown = error.response?.data
	if (!(data instanceof Blob)) return data ?? null
	try {
		return JSON.parse(await data.text())
	} catch {
		return null
	}
}

/**
 * The Slovenian `message` of an API refusal (apiErrorData()), or the fallback when there is none:
 * no response, a body that is not JSON, or no message string. Nothing else of the body is shown.
 */
export async function apiErrorMessage(error: unknown, fallback: string): Promise<string> {
	const message = ((await apiErrorData(error)) as { message?: unknown } | null)?.message
	return typeof message === 'string' && message.trim() !== '' ? message : fallback
}
